import React from 'react'
import { Switch, Route } from 'react-router-dom';
import { routesURLs } from '../../Routes';
import PersonalTestDetail from "./PersonalTestDetail";

const PersonalTest = () => {
    return (
        <Switch>
            <Route
                path={`${routesURLs.personalTest}/:id`}
                exact={true}
                render={(props) => <PersonalTestDetail {...props} />}
            />
        </Switch>
    );
}

export default PersonalTest
